export default {
    isSideMenuCollapsed(state) {
        return state.isSideMenuCollapsed;
    }
}